<template>
	<div>
		<app-header></app-header>
		<Row style="margin-top: 40px">
			<Col span="6">
				&nbsp;
			</Col>
			<Col span="12" style="background-color: #f8f8f9; border-radius:5%;">
				<div align="center">
					<Row>
						<Col>
							<label style="font-size: 24px;font-weight: bold;font-family: 'Helvetica Neue';">
								Update 2-Factor Authentication
							</label>
						</Col>
					</Row>
				</div>
				<Row style="margin-left: 30px; margin-top: 30px;">
					<label style="color: #41B8BC;font-size: 16px;">Step 1.&nbsp;</label>
					<label style="font-size: 14px;">Install the Google Authenticator app on your phone.</label>
				</Row>
				<Row style="margin-left: 100px;">
					<Col span="4" style=" margin-top: 30px;">
						<img src="../../../static/img/google_authenticator.jpg" style="width: 80px; height: 80px;">
					</Col>
					<Col span="10" style="margin-top: 30px;font-size: 16px;">
						<label>IOS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
						<a style="font-family: Helvetica;color: #41B8BC;" href="https://itunes.apple.com/cn/app/google-authenticator/id388497605" target="_blank">Download</a>
						<label>&nbsp;|&nbsp;</label>
						<a style="font-family: Helvetica;color: #41B8BC;" href="https://bigone.zendesk.com/hc/zh-cn/articles/115004699233" target="_blank">User Guide</a>
						<br>
						<label style="font-size:16px;">Android&nbsp;&nbsp;</label>
						<a style="font-family: Helvetica;color: #41B8BC;" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Download</a>
						<label>&nbsp;|&nbsp;</label>
						<a style="font-family: Helvetica;color: #41B8BC;" href="https://bigone.zendesk.com/hc/zh-cn/articles/115004714734" target="_blank">User Guide</a>
					</Col>
				</Row>
				<Row style="margin-left: 30px; margin-top: 30px;">
					<label style="color: #41B8BC;font-size: 16px;">Step 2.&nbsp;</label>
					<label style="font-size: 14px;">Scan the QR code below with the authenticator app.</label>
				</Row>
				<Row style="margin-left: 100px;">
					<Col span="4" style=" margin-top: 30px;">
						<img v-bind:src="qrcode" style="width: 160px; height: 160px;">
					</Col>
				</Row>
				<Row style="margin-left: 30px; margin-top: 30px;">
					<label style="color: #41B8BC;font-size: 16px;">Step 3.&nbsp;</label>
					<label style="font-size: 14px;">Write down this secret key and keep it in a safe place:</label>
				</Row>
				<Row style="margin-left:100px; margin-top: 20px;">
					<label style="font-size:28px;">{{formCustom.authenticationSecret}}</label>&nbsp;&nbsp;
                    <Icon type="ios-copy-outline" size="20" title="Copy secret key" @click="copySecretKey" class="secretKey" :data-clipboard-text="this.formCustom.authenticationSecret" color="#41B8BC" style="cursor:pointer;"></Icon>
					<br>
					<label style="font-size: 14px;">It may take up to <label style="color: red;">7 business days</label> if you try to restore 2FA without this key (e.g. your phone got lost or erased).</label>
				</Row>
				<Row style="margin-left: 30px; margin-top: 30px;">
					<label style="color: #41B8BC;font-size: 16px;">Step 4.&nbsp;</label>
					<label style="font-size: 14px;">Enter the 6-digit code displayed on your authenticator app below:</label>
				</Row>
				<Row style="margin-left: 100px; margin-top: 30px;">
					<Form ref="formCustom" :model="formCustom" :rules="ruleCustom">
						<FormItem prop="randomCode">
				            <Input type="text" v-model="formCustom.randomCode" style="width: 100px; height:30px;text-align: center;" placeholder="000000" size="large" :maxlength="6"></Input>
				            <Button @click="handleSubmit('formCustom')" size="large" style="margin-left: 30px;background: #41B8BC;">
                                <span style="font-family: Helvetica;color: #FFFFFF;">Submit</span>
                            </Button>
				        </FormItem>
				        <FormItem prop="id">
				            <Input type="hidden" disabled v-model="formCustom.id"></Input>
				        </FormItem>
				        <FormItem prop="authenticationSecret">
				            <Input type="hidden" disabled v-model="formCustom.authenticationSecret"></Input>
				        </FormItem>
                        <FormItem prop="qrcode">
                            <Input type="hidden" disabled v-model="formCustom.qrcode"></Input>
                        </FormItem>
				    </Form>
				</Row>
			</Col>
			<Col span="6">
				&nbsp;
			</Col>
		</Row>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import Clipboard from 'clipboard'
    import config from '../../config.js'
    export default {
        data(){
        	const validateId = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('  '));
                } else {
                    callback();
                }
            };
            const validateAuthenticationSecret = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(' '));
                } else {
                    callback();
                }
            };
            const validateRandomCode = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('The randomCode cannot be empty'));
                } else if (!Number.isInteger(+value)) {
                    callback(new Error('Please enter a numeric value'));
                } else if((value+'').length !== 6) {
                    callback(new Error('Must be 6 digits'));
                } else {
                	callback();
                }
            };
            return{
            	qrcode:'#',
                formCustom: {
                    id: '',
                    authenticationSecret: '',
                    qrcode: '#',
                    randomCode: '',
                },
                ruleCustom: {
                    id: [
                        { validator: validateId, trigger: 'blur' }
                    ],
                    authenticationSecret: [
                        { validator: validateAuthenticationSecret, trigger: 'blur' }
                    ],
                    randomCode: [
                        { validator: validateRandomCode, trigger: 'blur' }
                    ]
                },
                formAuthentication: {
                    id: '',
                },
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted:function(){
            this.getUser();
        },
        watch:{
            '$route':'getUser'
        },        
        methods: {
        	//获得用户详情信息
        	getUser:function(){
                let url = config.baseUrl + "user/getAuthentication";
                this.formAuthentication.id = this.$route.params.userId;
                let that = this;
                this.$http.post(url, this.formAuthentication).then(function(successData){
                    let data = successData.data;
                    that.formCustom.id = data.result.id;
                    that.formCustom.authenticationSecret = data.result.authenticationSecret;
                    that.qrcode = data.result.qrcode;
                },function(errorData){
                    this.$Message.error("Sorry, server error!");
                });
            },
            //复制认证秘钥
            copySecretKey(){
                var clipboard = new Clipboard('.secretKey');
                clipboard.on('success', e => {
                  this.$Message.success("Copy success!");
                  // 释放内存
                  clipboard.destroy();
                })
                clipboard.on('error', e => {
                  // 该浏览器不支持自动复制
                  this.$Message.error("The browser does not support automatic replication!");
                  // 释放内存
                  clipboard.destroy();
                })
            },
            //发送验证请求
        	handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.formCustom.qrcode = this.qrcode;
                        let url = config.baseUrl + "user/resetAuthentication";
                        this.$http.post(url, this.formCustom).then(function(successData){
                            let data = successData.data;
                            this.formCustom.randomCode = '';
                            if (data.resCode == 0) {
                                this.$Message.success("Success");
                                this.$router.push({name:'userSetting'})
                            }else if(data.resCode == -1){
                                this.$Message.error('Dangerous operation, please log in again!');
                            }else if(data.resCode == -2){
                                this.$Message.error('Verification code error!');
                            }else if(data.resCode == -3){
                                this.$Message.error("Sorry, server error!");
                            }
                        },function(errorData){
                            this.$Message.error('Fail!');
                            this.formCustom.randomCode = '';
                        });
                        
                    } else {
                        this.formCustom.randomCode = '';
                    }
                })
            },
        },

    }
</script>


// WEBPACK FOOTER //
// ResetAuthentication.vue?4418d547